import { render, staticRenderFns } from "./ClaimCreated.vue?vue&type=template&id=59d7ed42"
import script from "./ClaimCreated.vue?vue&type=script&lang=js"
export * from "./ClaimCreated.vue?vue&type=script&lang=js"
import style0 from "./ClaimCreated.vue?vue&type=style&index=0&id=59d7ed42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports